import { render, staticRenderFns } from "./r-product-dropdown-dialog.vue?vue&type=template&id=3e11c2a0&scoped=true"
import script from "./r-product-dropdown-dialog.vue?vue&type=script&lang=js"
export * from "./r-product-dropdown-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-product-dropdown-dialog.vue?vue&type=style&index=0&id=3e11c2a0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e11c2a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e11c2a0')) {
      api.createRecord('3e11c2a0', component.options)
    } else {
      api.reload('3e11c2a0', component.options)
    }
    module.hot.accept("./r-product-dropdown-dialog.vue?vue&type=template&id=3e11c2a0&scoped=true", function () {
      api.rerender('3e11c2a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/product/r-product-dropdown-dialog.vue"
export default component.exports